import { render, staticRenderFns } from "./AdblockModal.vue?vue&type=template&id=3579af6e&"
import script from "./AdblockModal.vue?vue&type=script&lang=js&"
export * from "./AdblockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports